import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../../services/http.service";

import { TranslateService } from "@ngx-translate/core";
import { Title, Meta } from "@angular/platform-browser";

declare var google;

@Component({
  selector: "app-view-detail",
  templateUrl: "./view-detail.component.html",
  styleUrls: ["./view-detail.component.scss"],
})
export class ViewDetailComponent implements OnInit {
  appIdFacebook = "";
  areas = [];
  array = [];
  id: number;
  latitude: number;
  longitude: number;
  address = "";
  audio = "";
  ext = "";
  photo = "";
  name = "";
  is = "";
  time = "";
  noise: number;
  status = "";
  type = "";
  color = "";
  legend: number;
  media: any;
  duration: number;
  control: any;
  thumb: any;
  timeLine: any;
  posTimeLine: number;
  link = "";
  isShare = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private httpService: HttpService,

    private translate: TranslateService,
    private title: Title,
    private meta: Meta
  ) {}

  ngOnInit() {
    let lang = "en";
    if (isPlatformBrowser(this.platformId)) {
      lang = sessionStorage.getItem("language");
      this.translate.use(lang);
      window.addEventListener("click", () => {
        if (event.target !== document.getElementById("b-share")) {
          this.isShare = false;
        }
      });
    }
    const that = this;

    /** 
    this.httpService.getInfoSocial().subscribe((data) => {
      that.appIdFacebook = that.filterSocial(data.data, "facebook")[0].app_id;
      const initParams: InitParams = {
        appId: that.appIdFacebook,
        cookie: true,
        xfbml: true,
        version: "v2.12",
      };
      if (isPlatformBrowser(this.platformId)) {
        that.fb.init(initParams);
      }
    });
    */

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.id = parseInt(params.get("id"), 0);
    });
    let newTime, weekday, time, date;
    this.httpService.getQuietAreas(lang).subscribe((data) => {
      if (data.err_code === 0) {
        this.areas = data.data.survey;
        this.array = [];
        this.areas.forEach((areas) => {
          areas.areas.forEach((area) => {
            this.array.push(area);
          });
        });
        const datas = this.array.filter((item) => item.id === that.id)[0];
        if (datas) {
          this.latitude = datas.latitude;
          this.longitude = datas.longitude;
          this.address = datas.address;
          this.audio = datas.audio;
          this.ext = this.audio
            .split(".")
            [this.audio.split(".").length - 1].toLowerCase();
          if (this.ext !== "ogg" && this.ext !== "wav") {
            this.ext = "mpeg";
          }
          this.translate.get(datas.name.split(" ")[0]).subscribe((res) => {
            this.name = res + " " + datas.name.substr(5);
          });
          this.translate.get("is").subscribe((res) => {
            this.is = res;
          });
          this.translate
            .get(
              (
                datas.noise_status.charAt(0).toUpperCase() +
                datas.noise_status.slice(1)
              ).trim()
            )
            .subscribe((res) => {
              this.status = res;
            });
          this.photo = datas.photo;
          this.title.setTitle(
            this.name + this.is + " " + this.status + " | Hushcity"
          );
          this.meta.addTags([
            { property: "og:title", content: this.name },
            {
              property: "og:description",
              content: this.name + " " + this.is + " " + this.status,
            },
            { property: "og:type", content: "article" },
            { property: "og:image", content: this.photo },
            { property: "twitter:card", content: "summary" },
            { property: "twitter:title", content: this.name },
            {
              property: "twitter:description",
              content: this.name + " " + this.is + " " + this.status,
            },
            { property: "twitter:image", content: this.photo },
          ]);
          if (isPlatformBrowser(this.platformId)) {
            this.link = location.href;
            newTime = new Date(datas.time * 1000);
            const optionsWeek: Intl.DateTimeFormatOptions = {
              timeZone: datas.timezone,
              weekday: "long",
            };
            weekday = new Intl.DateTimeFormat(
              sessionStorage.getItem("language"),
              optionsWeek
            ).format(newTime);
            const optionsDate: Intl.DateTimeFormatOptions = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              timeZone: datas.timezone,
            };
            newTime = new Intl.DateTimeFormat("en", optionsDate).format(
              newTime
            );
            /* time = (newTime.getHours() > 12 ?
                ('0' + (newTime.getHours() - 12)).toString().substr(-2) :
                ('0' + newTime.getHours())).substr(-2) +
                ':' + ('0' + newTime.getMinutes()).substr(-2) +
                (newTime.getHours() > 12 ? ' PM' : ' AM');
              date = ('0' + (newTime.getMonth() + 1)).substr(-2) +
                '/' + ('0' + newTime.getDate()).substr(-2) +
                '/' + newTime.getFullYear().toString().substr(-2); */
            time = newTime.split(", ")[1];
            date = newTime.split(", ")[0];
            this.time = weekday + " " + time + " " + date;
            this.noise = datas.noise_eq.toString().substring(0, 2);
            if (datas.noise_eq <= 35) {
              this.legend = 1;
              this.color = "color-legend01";
            } else if (datas.noise_eq > 35 && datas.noise_eq <= 40) {
              this.legend = 2;
              this.color = "color-legend02";
            } else if (datas.noise_eq > 40 && datas.noise_eq <= 45) {
              this.legend = 3;
              this.color = "color-legend03";
            } else if (datas.noise_eq > 45 && datas.noise_eq <= 50) {
              this.legend = 4;
              this.color = "color-legend04";
            } else if (datas.noise_eq > 50 && datas.noise_eq <= 55) {
              this.legend = 5;
              this.color = "color-legend05";
            } else if (datas.noise_eq > 55 && datas.noise_eq <= 60) {
              this.legend = 6;
              this.color = "color-legend06";
            } else if (datas.noise_eq > 60 && datas.noise_eq <= 65) {
              this.legend = 7;
              this.color = "color-legend07";
            } else if (datas.noise_eq > 65 && datas.noise_eq <= 70) {
              this.legend = 8;
              this.color = "color-legend08";
            } else if (datas.noise_eq > 70 && datas.noise_eq <= 75) {
              this.legend = 9;
              this.color = "color-legend09";
            } else if (datas.noise_eq > 75) {
              this.legend = 10;
              this.color = "color-legend10";
            }
            let img, imageArea;
            imageArea = document.getElementById("image-area");
            img = new Image();
            img.src = this.photo;
            img.onload = function () {
              if (this.width >= this.height) {
                imageArea.parentElement.classList.add("wh");
              } else {
                imageArea.parentElement.classList.add("hw");
              }
            };
            img.onerror = function () {
              imageArea.parentElement.classList.add("error");
            };
            const audioPlayer: HTMLMediaElement = <HTMLMediaElement>(
              document.getElementById("detail-audio")
            );
            audioPlayer.load();
          }
          this.initMap(this.latitude, this.longitude, datas.id);
        } else {
          // if (isPlatformBrowser(this.platformId)) {
          //   sessionStorage.removeItem('location');
          // }
        }
      } else {
        console.log(data);
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      this.control = document.getElementById("media-control");
      this.media = <HTMLMediaElement>document.getElementById("detail-audio");
      this.media.addEventListener("canplay", () => {
        this.control.addEventListener("click", onPlayMedia);
        this.duration = this.media.duration;
        this.thumb = document.getElementById("media-thumb");
        this.media.addEventListener("timeupdate", timeUpdate);
        const media = this.media;
        const duration = this.duration;
        const control = this.control;
        const thumb = this.thumb;
        function timeUpdate() {
          control.style.left =
            Math.round((media.currentTime / duration) * 100) + "%";
          thumb.style.width =
            Math.round((media.currentTime / duration) * 100) + "%";
          if (control.style.left === "100%") {
            control.classList.remove("media-pause");
            control.classList.add("media-play");
            control.style.left = 0;
            thumb.style.width = 0;
          }
        }
      });
    }
    const audio = this.media;
    const playpause = this.control;
    function onPlayMedia() {
      if (audio.paused) {
        audio.play();
        playpause.classList.remove("media-play");
        playpause.classList.add("media-pause");
      } else {
        audio.pause();
        playpause.classList.remove("media-pause");
        playpause.classList.add("media-play");
      }
    }
  }

  changeTimeline(event) {
    if (isPlatformBrowser(this.platformId)) {
      const timeLine = document.getElementById("media-fill");
      const posTimeLine = timeLine.getBoundingClientRect().left;
      this.media.currentTime =
        this.media.duration *
        ((event.clientX - posTimeLine) / timeLine.offsetWidth);
      this.control.style.left =
        (this.media.currentTime / this.media.duration) * 100 + "%";
      this.thumb.style.width =
        (this.media.currentTime / this.media.duration) * 100 + "%";
    }
  }

  initMap(latitude, longitude, id) {
    if (isPlatformBrowser(this.platformId)) {
      const that = this;
      const urlIcon = "assets/images/";
      const locationDefault = { lat: latitude, lng: longitude };
      const map = new google.maps.Map(document.getElementById("map-detail"), {
        center: locationDefault,
        zoom: 18,
        gestureHandling: "none",
        disableDefaultUI: true,
        styles: [{ stylers: [{ saturation: -100 }] }],
        /* styles: [
          {
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#dfdfdf'
              }
            ]
          },
          {
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#151515'
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#cccccc'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ededed'
              }
            ]
          },
          {
            'featureType': 'transit',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#c7c7c7'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#3d3d3d'
              }
            ]
          }
        ], */
        zoomControl: false,
      });
      const dmap = new google.maps.Map(document.getElementById("d-map"), {
        center: locationDefault,
        zoom: 18,
        gestureHandling: "none",
        disableDefaultUI: true,
        zoomControl: false,
      });

      /*
      const marker = new google.maps.Marker({
        position: locationDefault,
        label: {
          color: '#fff',
          fontSize: '18px',
          fontWeight: '500',
          text: '1'
        },
        icon: {
          labelOrigin: new google.maps.Point(19, 20),
          url: urlIcon + 'icon_quiet_' + this.legend + '.png'
        },
        map: map
      });
      */

      map.panBy(0, -20);

      /*
      marker.addListener('click', function () {
        sessionStorage.setItem('view-page', 'map-view');
        sessionStorage.setItem('current',
        '{ "center": { "lat": "' + latitude + '", "lng": "' + longitude + '" }, "zoom": ' + map.getZoom() + ' }');
        that.router.navigate(['/view-area']);
      });
      */
    }
  }

  filterSocial(arr, keyword) {
    return arr.filter((obj) =>
      Object.keys(obj).some((key) => obj[key].includes(keyword))
    );
  }

  showShare() {
    this.isShare = !this.isShare;
  }

  shareFacebook() {
    /** 
    if (isPlatformBrowser(this.platformId)) {
      const params: UIParams = {
        method: "share",
        href: location.href,
      };
      this.fb
        .ui(params)
        .then((res: UIResponse) => console.log(res))
        .catch((e: any) => console.error(e));
    }
        */
    this.isShare = false;
  }

  backView() {
    this.location.back();
  }
}
